import React from 'react';

import {NumberInput} from '../components/NumberInput';
import {BucketCustomization} from '../types';

export const NumberRangeInput = ({
  minField,
  maxField,
  minValue,
  maxValue,
  updateSetting,
  minDisabled,
  maxDisabled,
}: {
  minField: 'bucketMin';
  maxField: 'bucketMax';
  minValue: number | undefined;
  maxValue: number | undefined;
  minDisabled?: boolean;
  maxDisabled?: boolean;
  updateSetting: (settings: Partial<BucketCustomization>) => void;
}) => {
  return (
    <div className="flex w-2/3 gap-16">
      <NumberInput
        className="w-1/2"
        placeholder="Min"
        value={minValue}
        updateSetting={(newVal?: number) => {
          updateSetting({[minField]: newVal});
        }}
        disabled={minDisabled}
      />
      <NumberInput
        className="w-1/2"
        placeholder="Max"
        value={maxValue}
        updateSetting={(newVal?: number) => {
          updateSetting({[maxField]: newVal});
        }}
        disabled={maxDisabled}
      />
    </div>
  );
};
